<!--
 * @Author: your name
 * @Date: 2021-01-05 09:47:13
 * @LastEditTime: 2021-01-08 11:42:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sunshineServiceHall\src\components\appeal\replyInfo.vue
-->
<template>
  <div style="width: 1200px">
    <div class="tablez_bg">
      <div class="title">
        您当前的位置：
        <router-link to="/home">阳光校务服务大厅</router-link>
        &gt; 阳光校务信息台详情
      </div>
    </div>

    <div class="body">
      <div class="bodyRow">
        <div class="bodyRowItem noBorder">信件主题:</div>
        <div class="bodyRowItem row" :title="record.name" style="width: 46%">
          {{ record.name }}
        </div>
        <div class="bodyRowItem">受理单位:</div>
        <div class="bodyRowItem" style="width: 32%">{{ record.orgName }}</div>
      </div>
      <div class="bodyRow">
        <div class="bodyRowItem noBorder">问题类别:</div>
        <div class="bodyRowItem" style="width: 46%">{{ record.typeName }}</div>
        <div class="bodyRowItem ">手机号码:</div>
        <div class="bodyRowItem" style="width: 32%">
          {{ record.mobile ? record.mobile.replace(/^(\d+)(\d{6})$/, "$1******") : '' }}
        </div>
      </div>
      <!--      <div class="bodyRow">-->
      <!--        <div class="bodyRowItem">信件来源:</div>-->
      <!--        <div class="bodyRowItem" style="width: 32%">-->
      <!--          {{ record.userName ? record.userName.substring(0, 1) + "**" : "" }}-->
      <!--        </div>-->
      <!--        <div class="bodyRowItem">联系方式:</div>-->
      <!--        <div class="bodyRowItem" style="width: 32%">-->
      <!--          {{ record.email ? record.email.substring(0, 1) + "**" : "" }}-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="bodyRow">
        <div class="bodyRowItem noBorder">点击次数:</div>
        <div class="bodyRowItem" style="width: 46%">{{ record.count }}</div>
        <div class="bodyRowItem">当前状态:</div>
        <div class="bodyRowItem" style="width: 32%">
          {{
            record.status === 0 ? '未受理' : record.status === 1 ? "已受理" : record.status === 2 ? "已完成" : record.status === 3 ? "已转交" : record.status === 4 ? "不受理" : ""
          }}
        </div>
        <!--        <div class="bodyRowItem">学号/教工号:</div>-->
        <!--        <div class="bodyRowItem" style="width: 32%">-->
        <!--          {{ record.workNo ? record.workNo.substring(0, 1) + "**" : "" }}-->
        <!--        </div>-->
      </div>
      <div class="bodyRow">
        <div class="bodyRowItem noBorder">提交时间:</div>
        <div class="bodyRowItem" style="width: 46%">{{ record.gmtCreate }}</div>
        <div class="bodyRowItem">办结时间:</div>
        <div class="bodyRowItem" style="width: 32%">
          {{ record.processingTime ? record.processingTime : "无" }}
        </div>
      </div>
      <div class="bodyRow" v-if="record.typeOne&&(record.typeOne==='我要投诉'||record.typeOne==='我要咨询')">
        <div v-if="record.typeOne==='我要投诉'||record.typeOne==='我要咨询'" class="bodyRowItem noBorder">所属院系/身份:</div>
        <div v-if="record.typeOne==='我要投诉'||record.typeOne==='我要咨询'" class="bodyRowItem" style="width: 46%;">
          <div>{{ record.college }}</div>
        </div>
        <div v-if="record.typeOne==='我要投诉'" class="bodyRowItem">是否匿名发布:</div>
        <div v-if="record.typeOne==='我要投诉'" class="bodyRowItem" style="width: 32%">
          {{ record.userType === 3 ? "是" : '否' }}
        </div>
      </div>
      <div class="bodyRow">
        <div class="bodyRowItem noBorder">诉求内容:</div>
        <div class="bodyRowItem" style="width: 89%; min-height: 150px">
          <div style="width: 100%;word-break:break-all;" v-html="record.content"></div>
        </div>
      </div>
      <div class="bodyRow">
        <div class="bodyRowItem noBorder">附件:</div>
        <div class="bodyRowItem" style="width: 89%">
          <a v-if="record.filePath" @click="down(record.filePath)">{{
              record.filePath
            }}</a>
          <span v-else>无</span>
        </div>
      </div>
      <!--      <div class="bodyRow " v-if="record.logs?record.logs.length>0:false">-->
      <!--        <div class="bodyRowItem noBorder">转交记录：</div>-->
      <!--        <div class="bodyRowItem" style="width: 89%; min-height: 150px">-->
      <!--          <a-timeline>-->
      <!--            <a-timeline-item v-for="(item,index) in record.logs" :key="index">-->
      <!--              【{{ item.beforeOrg ? item.beforeOrg : '管理员' }}】&#45;&#45; 【{{ item.afterOrg }}】{{ item.description }} &#45;&#45;-->
      <!--              {{ item.time }}-->
      <!--            </a-timeline-item>-->
      <!--          </a-timeline>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="bodyRow " v-if="record.replyLogs?record.replyLogs.length>0:false">
        <div class="bodyRowItem noBorder">回复内容：</div>
        <div class="bodyRowItem" style="width: 89%; min-height: 150px">
          <a-timeline>
            <a-timeline-item v-for="(item,index) in record.replyLogs" :key="index">
              【{{ item.orgName }}】： {{ item.reply }} -- {{ item.gmtCreate }}
            </a-timeline-item>
          </a-timeline>
        </div>
      </div>
      <div class="bodyRow noBorder" v-if="record.status === 2">
        <div class="bodyRowItem noBorder">评价意见:</div>
        <div class="bodyRowItem" style="width: 89%; min-height: 150px">
          <a-radio-group v-if="record.satisfaction === null&&isMe===1" name="radioGroup" v-model="satisfaction">
            <div style="display: flex; align-items: center">
              <img style="margin-right: 5px" src="@/assets/good.png" alt=""/>
              <a-radio :value="1"> 非常满意</a-radio>
              <img
                  style="margin-right: 5px"
                  src="@/assets/prefect.png"
                  alt=""
              />
              <a-radio :value="2"> 满意</a-radio>
              <img style="margin-right: 5px" src="@/assets/so.png" alt=""/>
              <a-radio :value="3"> 一般</a-radio>
              <img style="margin-right: 5px" src="@/assets/bad.png" alt=""/>
              <a-radio :value="4"> 不满意</a-radio>
            </div>
          </a-radio-group>
          <div v-else style="display: flex; align-items: center">
            <img style="margin-right: 5px" alt="" :src="
             record.satisfaction === 1
                ? require('@/assets/good.png')
                  : record.satisfaction === 2
                  ? require('@/assets/prefect.png')
                  : record.satisfaction === 3
                  ? require('@/assets/so.png')
                  : record.satisfaction === 4
                  ? require('@/assets/bad.png')
                  : ''
              "
            />
            {{
              record.satisfaction === 1
                  ? "非常满意"
                  : record.satisfaction === 2
                  ? "满意"
                  : record.satisfaction === 3
                      ? "一般"
                      : record.satisfaction === 4
                          ? "不满意"
                          : ""
            }}
          </div>
          <!--          <div v-if="isMe===1" style="color: red">如您对受理回复不满意，可转到-->
          <!--            <router-link to="/leaderDo">领导信箱</router-link>-->
          <!--          </div>-->
          <div v-if="record.userReply === null&&isMe===1">
            <div style="margin-top: 20px">附加评论说明:</div>
            <a-textarea
                :rows="5"
                style="width: 300px; margin-bottom: 20px"
                v-model="reply"
            ></a-textarea>
          </div>
          <div v-else style="width: 300px;padding: 10px;margin-top: 10px;">
            {{ record.userReply }}
          </div>
          <div v-if="(record.reply === null || record.satisfaction === null)&&isMe===1">
            <a-button @click="submit">评论</a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getAction, postAction} from "@/api/manage";

export default {
  data() {
    return {
      record: {},
      satisfaction: 1,
      reply: "",
      code: "",
      isMe: 0
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    down(path) {
      window.open(
          window._CONFIG["url"] + "/common/file/downLoadByJava" + "?path=" + path
      );
    },
    getInfo() {
      let record = JSON.parse(decodeURIComponent(this.$route.query.record));
      this.isMe = record.isMe ? record.isMe : 0
      getAction('/user/appeal/appeal/getDetails', {id: record.id}).then((data) => {
        if (data.code === 0) {
          this.record = data.data
        } else {
          this.$message.error(data.message)
        }
      })
    },
    submit() {
      let _this = this;
      let params = {
        id: _this.record.id,
        reply: _this.reply,
        satisfaction: _this.satisfaction,
      };
      postAction("/user/appeal/appeal/user/addReply", params).then((data) => {
        if (data.code === 0) {
          _this.$notification["success"]({
            message: "提示",
            description: "操作成功!",
          });
          _this.getInfo()
        } else {
          _this.$notification["error"]({
            message: "提示",
            description: data.message,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.body {
  border: 1px solid #e6e6e6;
  margin-top: 10px;
}

.bodyRow {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
}

.bodyRowItem {
  padding: 10px;
  border-left: 1px solid #e6e6e6;
  width: 11%;
  height: 100%;
}

.noBorder {
  border: none;
}

.row {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
